import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import CalendarLoader from "../../../common-components/CalendarLoader";

const WeightLogsDatewise = () => {
  const { memberWeight, memberWeightError, memberWeightLoading } = useSelector(
    (state) => state.prospects
  );

  const [weightStats, setWeightStats] = useState([]);

  const sortedStats = [...weightStats].sort(
    (a, b) => parseInt(a.date_added) - parseInt(b.date_added)
  );

  useEffect(() => {
    if (
      !memberWeightError &&
      !memberWeightLoading &&
      memberWeight?.status &&
      memberWeight?.data
    ) {
      setWeightStats(memberWeight.data?.[0]?.stats || []);
    } else {
      setWeightStats([]);
    }
  }, [memberWeight, memberWeightError, memberWeightLoading]);

  return (
    <div className="tme-analysis-chart-logs-section tme-analysis-chart-logs-blue">
      <h4 className="tme-analysis-chart-logs-title">Weight Logs Comparison</h4>

      <div className="tme-analysis-chart-logs-grid">
        {memberWeightLoading ? (
          <CalendarLoader daysCount={4} />
        ) : (
          sortedStats.map((log, idx) => {
            const currentWeight = parseFloat(log?.weight || 0);
            const prevWeight =
              idx > 0 ? parseFloat(sortedStats[idx - 1]?.weight) : null;
            const change = prevWeight
              ? (currentWeight - prevWeight).toFixed(1)
              : null;
            const changeType = change ? (change < 0 ? "down" : "up") : null;

            return (
              <div key={log?.uid} className="tme-analysis-chart-log-card">
                <div className="tme-analysis-chart-log-day">
                  {moment(log?.date, "DD-MM-YYYY").format("dddd, MMMM YYYY")}
                </div>
                <div className="tme-analysis-chart-log-value">
                  {log?.weight || 0}
                </div>
                {change && (
                  <div
                    className={`tme-analysis-chart-log-change ${
                      changeType === "down"
                        ? "tme-analysis-chart-change-up"
                        : "tme-analysis-chart-change-down"
                    }`}
                  >
                    {changeType === "down" ? "↘" : "↗"} {change}
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default WeightLogsDatewise;
